import { SET_PASSBOOK_DATA, FETCH_PASSBOOK_DATA } from './constants';

const initialState = {
  loading: false,
  loaded: false,
  transactionData: {},
};

const passbook = (state: any = initialState, action: any) => {
  switch (action.type) {
    case FETCH_PASSBOOK_DATA:
      return {
        ...state,
        loading: true,
        loaded: action.data.fetchMore ? true : false,
      };
    case SET_PASSBOOK_DATA: {
      let list: Array<object> = [];
      if (!action.data.reset) {
        if (state.transactionData.list && state.transactionData.list.length) {
          list = [...list, ...state.transactionData.list];
        }
      }
      if (action.data.list && action.data.list.length) {
        list = [...list, ...action.data.list];
      }
      return {
        ...state,
        transactionData: {
          ...action.data,
          list,
        },
        loaded: true,
      };
    }
    default:
      return state;
  }
};

export default passbook;
